import React from 'react'
import Moment from 'react-moment';

const dateDisplay = (props) => {

    return(<Moment date={props.date} parse={"DD MMM YYYY 'at' LT"} format={"LLL"}/>)
};

export default dateDisplay;